import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-85" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-86" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-87" data-mp="4njnu5x67n8v">
          🌸 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" data-id="element-88" data-mp="nc858hwg3afw">
          Maîtrisez le coréen en 60 minutes : de l'alphabet à la fluidité
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px"
      }} data-id="element-89" data-mp="381xl8y8vx2a6">
          APPRENEZ À LIRE LE HANGEUL EN PARTANT DE ZÉRO GRÂCE À UNE MÉTHODE VISUELLE
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-90" data-mp="39acxmohxzmt0">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-91" data-mp="30fy9rxjcj3ya" />
          <img src="https://cdn.magicpatterns.com/uploads/9aoXbAja7igVuHRapPGDas/ChatGPT_Image_31_ago_2026,_17_51_06.png" alt="Coréen Express — ebook plus 5 bonus en format numérique" width={1248} height={1248} className="animate-floaty mx-auto aspect-square w-full max-w-full rounded-2xl object-contain" data-id="element-92" data-mp="2qkdc2blb8puc" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-93" data-mp="2ljgy1578vnb7">
          ⭐ 4.9 (500+ étudiants satisfaits) · ⚡ Accès instantané
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-94" data-mp="ia5imwc0kftn">
          <CTAButton href="#value" data-id="element-95" data-mp="de6o0r03e1ks">Obtenez le pack Coréen Express</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-96" data-mp="1b0nmw0oh4n8n">
            Commencez à comprendre le coréen depuis zéro, même si vous n'avez jamais étudié de
            langues auparavant. Apprenez le Hangeul, des phrases réelles, le vocabulaire essentiel
            et les expressions de K-Drama / K-Pop avec une méthode visuelle, simple et organisée.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-97" data-mp="3lsp2bagmmdcu">
            Hangeul · Prononciation · Vocabulaire · Expressions K-Drama · Système K-SMART
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-98" data-mp="218tl3i9lym8j">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-99" data-mp="2b0zcoqvy71n7">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-100" data-mp="2kynbpt0l6vb6" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-101" data-mp="2p08we0jd4dvx">
            Ebook + 5 bonus · 120+ pages — Tout ce dont vous avez besoin en un seul endroit.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-102" data-mp="umzgnr083w58">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-103" data-mp="4b47lugz66jz">
              <Icon className="h-4 w-4 text-grape" data-id="element-104" data-mp="4d78j9jo1k3h" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-105" data-mp="e9jxju49n9rw">
          🔥 Offre à durée limitée · Puis le prix revient à 49,99€
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-106" data-mp="3ri6h8sef3lix">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-107" data-mp="2yzsvhr6cvq07" />
          27 personnes regardent ce produit en ce moment
        </p>
      </div>
    </header>;
}